import { render, staticRenderFns } from "./siteSupersision.vue?vue&type=template&id=2b0d1cd8&"
import script from "./siteSupersision.vue?vue&type=script&lang=js&"
export * from "./siteSupersision.vue?vue&type=script&lang=js&"
import style0 from "./siteSupersision.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports